import React from 'react';

import logos from './supplierLogos';
import displayValues from '../../../resources/displayValues.json';
import { Offer } from '@/interfaces';

type LoadingValue = 'eager' | 'lazy';
type Props = Pick<Offer, 'supplier'> & { className?: string; loading?: LoadingValue };

const supplierDisplayNames = displayValues.suppliers as Record<string, string>;

export const SupplierLogo: React.FC<Props> = ({ supplier, className, loading = 'lazy' }: Props): React.ReactElement<Props> => {
    const logoAttributes = logos()[supplier?.toLowerCase()];

    try {
        return logoAttributes ? (
            <img
                src={logoAttributes.src}
                height={logoAttributes.height}
                width={logoAttributes.width}
                loading={loading}
                className={className}
                alt={`${supplierDisplayNames[supplier]}`}
            />
        ) : (
            <span />
        );
    } catch (e) {
        // missing image, ignore
        return <span />;
    }
};
